

export const LinkInApp = ({ label, onClick }: { label: string, onClick: () => void }) => {
	return (
		<span 
			onClick={onClick}
			style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
		>
			{label}
		</span>
	)
}